<h3 translate>Task Description</h3>
<p>{{ task?.description || '-' }}</p>

<h3 class="notice" translate>Notice</h3>
<p>{{ task?.notice || '-' }}</p>

@if (!task?.skipInfo && !task?.finishInfo) {
  <mat-expansion-panel class="expansion-panel-override">
    <mat-expansion-panel-header><h3 translate>Details</h3></mat-expansion-panel-header>
    <ng-container *ngTemplateOutlet="mainContent; context: { $implicit: task }"></ng-container>
  </mat-expansion-panel>
}

@if (!!task?.skipInfo || !!task?.finishInfo) {
  <div class="history-details">
    <h3 translate>Details</h3>
    <ng-container *ngTemplateOutlet="mainContent; context: { $implicit: task }"></ng-container>
  </div>
}

<ng-template #mainContent>
  <div class="_flex-row">
    @for (detailRow of details; track detailRow) {
      <table>
        <caption translate hidden>
          Details
        </caption>
        @for (detail of detailRow; track detail) {
          <tr>
            <th scope="row">{{ detail.name | translate }}</th>
            <td>{{ detail.value }}</td>
          </tr>
        }
      </table>
    }
  </div>

  <h3>
    {{ (task?.scheduling ? 'Notes for all tasks in the series' : 'Notes for task') | translate }}
  </h3>
  @if (!!task?.executionDate) {
    <p>{{ task?.notes || '-' }}</p>
  }
  @if (readonly) {
    <p>{{ task?.notes }}</p>
  } @else {
    @if (!task?.executionDate) {
      <rotec-textarea-v2
        minHeight="100px"
        [value]="task?.notes"
        [darkMode]="true"
        [placeholder]="
          (task?.scheduling
            ? 'Important notes for all tasks in the series'
            : 'Important notes for task'
          ) | translate
        "
        (valueChange)="notes$.next($event)"
      ></rotec-textarea-v2>
    }
  }
  <ma-image-slider [pictureIds]="task?.pictureIds"></ma-image-slider>
</ng-template>
